module.exports = __webpack_public_path__ + "img/hr-ccombinator-displays.f16e6d5d.png";